module.exports = __webpack_public_path__ + "img/KSC07623.49afbffe.jpg";